import React from 'react';
import { ReleaseShiftModalProps, ReleaseStep } from './interface';
import { useProNavigate } from '@mp/contexts';
import { ReleaseStatus } from '../interface';
import { useShiftSwapMutations } from '../mutations';

export const useReleaseShift = ({
  jobId,
  onClose,
}: Pick<ReleaseShiftModalProps, 'jobId' | 'onClose'>) => {
  const [releaseStatus, setReleaseStatus] = React.useState<ReleaseStatus | null>(null);
  const [releaseStep, setReleaseStep] = React.useState<ReleaseStep>('releaseOptions');
  const [requesteeId, setRequesteeId] = React.useState<number | undefined>(undefined);

  const { navigate } = useProNavigate();
  const { addShiftRequest, isLoading } = useShiftSwapMutations();

  const handleClick = () => {
    if (releaseStatus === 'swap' && releaseStep === 'releaseOptions') {
      setReleaseStep('prosToSwap');
    } else {
      addShiftRequest({
        request_type: releaseStatus as ReleaseStatus,
        jobId: jobId as number,
        requestee_id: requesteeId,
      });
      setReleaseStep('releaseOptions');
      setReleaseStatus(null);
      setRequesteeId(undefined);
      navigate('JobDetails', { id: jobId as number });
      onClose();
    }
  };

  const getTitle = () => {
    return releaseStep === 'prosToSwap' ? 'Release shift to:' : 'Release shift';
  };

  const buttonLabel = () => {
    if (releaseStatus === 'release' || releaseStep === 'prosToSwap') {
      return 'Release shift';
    }
    if (releaseStatus === 'drop') {
      return 'Drop shift';
    }
    return 'Continue';
  };

  const disableContinueButton =
    releaseStatus === 'swap' && releaseStep === 'prosToSwap' && !requesteeId;

  return {
    releaseStatus,
    setReleaseStatus,
    releaseStep,
    setReleaseStep,
    getTitle,
    handleClick,
    buttonLabel,
    getRequesteeId: setRequesteeId,
    disableContinueButton,
    isButtonLoading: isLoading,
  };
};
